import { render, staticRenderFns } from "./year.vue?vue&type=template&id=32e46ea2&scoped=true&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=32e46ea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e46ea2",
  null
  
)

export default component.exports